import React, { useState, useCallback, useMemo } from 'react'
import { type GroupProps } from 'react-select'
import _groupBy from 'lodash/groupBy'
import { type GroupedOptions } from 'domains/account-management/components/retailer-location-store-group-select/utils/types'
import { GroupHeading } from './GroupHeading'

export const Group = (props: GroupProps<GroupedOptions> & { data: GroupedOptions }) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false)

  const { children, data, getValue, setValue } = props
  const { type, options } = data

  const selectedValues = getValue() as unknown as GroupedOptions['options']
  const groupedSelectedValues = useMemo(() => _groupBy(selectedValues, 'type'), [selectedValues])

  const checked =
    groupedSelectedValues[type] === undefined
      ? false
      : groupedSelectedValues[type]?.length === options?.length
      ? true
      : 'indeterminate'

  const handleExpandToggleClick = useCallback(() => {
    setIsExpanded(!isExpanded)
  }, [isExpanded])

  const handleCheckBoxClick = useCallback(() => {
    if (checked) {
      setValue(
        // @ts-ignore react-style is incorrect applying the the of GroupedOptions to the value when its of type GroupedOptions['options']
        selectedValues.filter(value => value.type !== type),
        'select-option'
      )
    } else {
      // @ts-ignore react-style is incorrect applying the the of GroupedOptions to the value GroupedOptions['options']
      setValue([...selectedValues, ...options], 'select-option')
    }
  }, [checked, options, selectedValues, setValue, type])

  return (
    <div>
      <GroupHeading
        type={type}
        checked={checked}
        count={options.length}
        onClick={handleExpandToggleClick}
        onClickCheckbox={handleCheckBoxClick}
        expanded={isExpanded}
      />
      <div css={{ display: isExpanded ? 'block' : 'none' }}>{children}</div>
    </div>
  )
}
